import {useState} from "react";

import {useGenerateSisbagalReport} from "./useGenerateSisbagalReport";

import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const SisbagalMapDownloadPdfAction = ({
    generateMapAsPng,
    getMapAsPngDimensions,
    entityData = {},
}) => {
    const [loading, setLoading] = useState(false);

    const {generate} = useGenerateSisbagalReport();

    const handleGeneratePDF = async () => {
        setLoading(true);
        await generate({generateMapAsPng, getMapAsPngDimensions, entityData});
        setLoading(false);
    };

    return (
        <Box
            sx={{
                width: "40px",
                height: "40px",
            }}
        >
            {loading ? (
                <CircularProgress size={22} sx={{ml: 1, mt: 1}} />
            ) : (
                <Tooltip title={"Descargar como PDF"}>
                    <IconButton
                        aria-label="download-pdf"
                        onClick={handleGeneratePDF}
                        color="primary"
                    >
                        <PrintOutlinedIcon />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
};

export default SisbagalMapDownloadPdfAction;
